import { combineReducers } from 'redux'
import {
    ReducerApp
} from './ReducerApp'
import {
    ReducerAdmin
} from './ReducerAdmin'
import {
    ReducerLogin
} from './ReducerLogin'

export default combineReducers({
    ReducerApp,
    ReducerAdmin,
    ReducerLogin
})



// WEBPACK FOOTER //
// ./src/Reducers/index.js